module.exports = __webpack_public_path__ + "assets/img/title-ecd9270c.png";